import { render, staticRenderFns } from "./startPage.vue?vue&type=template&id=6781f8c9&"
import script from "./startPage.vue?vue&type=script&lang=ts&"
export * from "./startPage.vue?vue&type=script&lang=ts&"
import style0 from "./startPage.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports